import { createContext, useContext, useEffect, useState } from "react";

const AdminThemeContext = createContext(null);
const STORAGE_KEY = "nhp_admin_theme";

export function AdminThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "light" ? "light" : "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
    // Radix portals (Dialog, Select, dropdowns...) render into document.body,
    // outside AdminLayout's own DOM subtree — CSS custom properties don't
    // cross that boundary, so the theme class must live on body itself for
    // portalled content to see --nhp-* at all.
    document.body.classList.remove("nhp-dark", "nhp-light");
    document.body.classList.add(`nhp-${theme}`);
    return () => { document.body.classList.remove("nhp-dark", "nhp-light"); };
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <AdminThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </AdminThemeContext.Provider>
  );
}

export function useAdminTheme() {
  const ctx = useContext(AdminThemeContext);
  if (!ctx) throw new Error("useAdminTheme must be used within AdminThemeProvider");
  return ctx;
}
